'use strict';
var async = require('async');
var createDataGridFilterPersistence = require('./dataGridFilterPersistence').createDataGridFilterPersistence;
// the excel
var XLSX = require('xlsx-browserify-shim');
var csvParse = require('csv-parse');
var saveAs = require('../fileSaver');

module.exports = function (form, $state, $scope, gridConfiguration, Department, departments, Form, dialog, $translate, Authentication, $rootScope, $serverData, toast, $http, $timeout) {
    var _this = this;
    this.Department = Department;
    this.Form = Form;
    this.itemxPage = 250
    _this.filteredItems = [];
    this.form = form;
    _this.selectedItems = null;
    this.currentUserIsAdmin = Authentication.isAuthorized("admin");
    this.currentUserIsViewer = Authentication.isAuthorized("viewer");
    this.currentUserIsSupervisor = Authentication.isAuthorized("supervisor");
    console.log(1);
    this.showNavs = !(localStorage.getItem('validationFormHideNavBar') === "1"); // for Validaction - Forms
    this.currentUserIsTeamLeader = false;
    _this.loading = false;
    _this.hasActiveFilters = false;
    this.executedActions = [];
    this.processingActions = false;
    this.executedReports = [];
    this.processingReports = false;
    this.generatingPdf = false;

    // FOR VALIDACION FILTERS
    // this.valuesPendingValidation = ["Aprobado", "Rechazado"]; // Values to show on Validación filter
    this.valuesPendingValidation = [
        $translate.instant("DASHBOARD.DASH_VALIDATIONS.STATES.OK"), // "Aprobado",
        $translate.instant("DASHBOARD.DASH_VALIDATIONS.STATES.REJECT"),// "Rechazado"
    ];
    this.pendingIndexes = new Map();

    if (this.form.teams.some((team) => team.teamMembers?.length > 0 && team.teamMembers[0].isTeamLeader)) {
        this.currentUserIsTeamLeader = true;
    }
    // console.log('this.currentUserIsTeamLeader', this.currentUserIsTeamLeader == true)

    if (this.form.validate_type == "instance-defined") {
        this.form.validate_defined.forEach((instance, index) => {
            let name = '';
            if (instance.input.trim() != '') {
                // name = "Pendiente" + " " + instance.input.trim();
                name = instance.input.trim();
            } else {
                name = $translate.instant("DASHBOARD.DASH_VALIDATIONS.STATES.PENDING") + " #" + (index + 1); // "Pendiente"
            }
            _this.valuesPendingValidation.push(name);
            _this.pendingIndexes.set(name, index);
        })
    } else {
        // Case 1
        if (this.form.validate_instances == 1) {
            _this.valuesPendingValidation.push($translate.instant("DASHBOARD.DASH_VALIDATIONS.STATES.PENDING")); // "Pendiente"
        }
        // Case >1
        else {
            for (let index = 0; index < this.form.validate_instances; index++) {
                let instanceLeft = _this.form.validate_instances - index;
                let name = $translate.instant("DASHBOARD.DASH_VALIDATIONS.STATES.PENDING") + " " + instanceLeft; // "Pendiente"
                _this.valuesPendingValidation.push(name);
                _this.pendingIndexes.set(name, index);
            }
        }
    }

    this.owners = [];
    this.department = departments?.filter(function (department) {
        return department.id === $state.params.departmentId;
    })[0];
    if (Array.isArray(this.department.owners))
        this.department.owners.forEach((owner) => {
            _this.owners.push(owner.firstName + " " + owner.lastName + " | " + owner.id);
        });
    else
        this.department.owners = [];

    this.lstUsuarios = [];
    this.lstMails = [];
    this.lstFieldsArchived = [];

    _this.gridInitState = false;
    _this.gridRestoringPreferences = false;
    _this.filterPrefs = createDataGridFilterPersistence({
        $timeout,
        getFormId: () => _this.form && _this.form.id,
        hasTaskId: () => $state.params.taskId != undefined,
        getGridOptions: () => _this.gridOptions,
        getGridInitState: () => _this.gridInitState,
        getGridRestoringPreferences: () => _this.gridRestoringPreferences,
        setGridRestoringPreferences: (value) => { _this.gridRestoringPreferences = value; },
        refreshData: () => _this.refreshData()
    });

    if (!this.currentUserIsViewer) {
        this.Department.teams({
            id: $state.params.departmentId,
            filter: {
                include: {
                    relation: 'members',
                }
            }
        })
            .$promise
            .then(function (teams) {
                teams.forEach(t => {
                    t.members.forEach(m => {
                        if (!_this.lstUsuarios.includes(m.firstName + " " + m.lastName + " | " + m.id)) {
                            _this.lstUsuarios.push(m.firstName + " " + m.lastName + " | " + m.id);
                            _this.lstMails.push(m.email + " | " + m.id);
                        }
                    })
                });
                _this.lstUsuarios.sort();
                _this.lstMails.sort();
                _this.filterPrefs.restoreFromStorage();
            })
            .catch(function (error) { });
    }

    // Si hay ítems seleccionados exporta esos; si no, exporta lo que se está mostrando en la grilla (respetando el filtro aplicado).
    _this.getRowsToExport = () => {
        if (_this.selectedItems && _this.selectedItems.length > 0) {
            return _this.selectedItems;
        }
        return (_this.filteredItems && _this.filteredItems.length > 0) ? _this.filteredItems : _this.itemsBkp;
    };

    // setRowData descarta el modelo de filtros, por lo que lo preservamos y lo reaplicamos para no perder el filtro previo.
    _this.restoreGridAfterExport = (filterModel) => {
        _this.gridOptions.api.setRowData(_this.itemsBkp);
        if (filterModel && Object.keys(filterModel).length > 0) {
            _this.gridOptions.api.setFilterModel(filterModel);
        }
    };

    _this.exportCSV = function () {
        const filterModel = _this.gridOptions.api.getFilterModel();
        _this.gridOptions.api.setRowData(_this.getRowsToExport());
        _this.gridOptions.api.exportDataAsCsv({
            fileName: _this.form.name.replace(' ', '_') + '.csv'
        });
        _this.restoreGridAfterExport(filterModel);
    };

    _this.getAppliedGridFilterModel = function () {
        if (!_this.filterPrefs || !_this.gridOptions || !_this.gridOptions.api) {
            return {};
        }
        return _this.filterPrefs.buildFilterModelFromGrid(
            _this.gridOptions.api.getFilterModel && _this.gridOptions.api.getFilterModel()
        );
    };

    _this.hasAppliedGridFilters = function () {
        const fm = _this.getAppliedGridFilterModel();
        return fm && typeof fm === 'object' && Object.keys(fm).length > 0;
    };

    _this.updateActiveFiltersState = function () {
        _this.hasActiveFilters = _this.hasAppliedGridFilters();
    };

    _this.notifyValidationModalFiltersState = function () {
        _this.updateActiveFiltersState();
        try {
            if (!window.parent || window.parent === window || !_this.form || !_this.form.id) {
                return;
            }
            window.parent.postMessage({
                type: 'dataGrid-filtersState',
                formId: _this.form.id,
                hasActiveFilters: _this.hasAppliedGridFilters()
            }, '*');
        } catch (e) { }
    };

    _this.resetFilters = function () {
        if (_this.gridOptions && _this.gridOptions.api) {
            _this.filterPrefs.reset();
            // setFilterModel(null) ya dispara setDatasource con enableServerSideFilter;
            // no llamar refreshData() para evitar myItems duplicados.
            _this.loading = true;
            _this.gridOptions.api.setFilterModel(null);
            if (_this.gridInitState && _this.filterPrefs.canPersist()) {
                _this.filterPrefs.persistToLocalStorage();
            }
            $timeout(function () {
                _this.notifyValidationModalFiltersState();
            }, 0);
        }
    };

    _this.resetGrid = function () {
        window.localStorage.removeItem(_this.filterPrefs.getLocalStorageKey());
        if (_this.gridOptions && _this.gridOptions.api) {
            _this.gridOptions.api.setFilterModel(null);
        }
        _this.gridInitState = false;
        _this.filterPrefs.clearAllState();
        _this.gridOptions.api.setColumnDefs([]);
        _this.gridOptions.api.setColumnDefs(columnDefs);
    };
    _this.downloadURL = (url) => {
        const data = JSON.stringify(data)
        const link = document.createElement('a')
        const filename = url.substr(url.lastIndexOf("/") + 1);
        link.setAttribute('href', url);
        link.setAttribute('download', "");
        link.setAttribute('target', "_blank");

        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }


    _this.downloadPDF = function () {
        console.log(_this.selectedItems);
        if (_this.selectedItems.length > 0) {
            _this.generatingPdf = true;
            let item = _this.selectedItems.pop();
            Department.pdf({
                departmentId: item.deptId,
                formId: item.formId,
                itemId: item.id
            })
                .$promise.then(function (response) {
                    _this.loading = false;
                    var pdfUrl = response.response;

                    //window.open($serverData.server + pdfUrl, "_blank");
                    _this.downloadURL($serverData.server + pdfUrl);
                    //_this.downloadPDF();
                    if (_this.selectedItems.length == 0)
                        _this.generatingPdf = false;
                    else
                        setTimeout(_this.downloadPDF, 2000)
                    return;
                })
                .catch(function () {
                    _this.generatingPdf = false;
                    return;
                });
        }
    }
    

    // ACCIONES
    _this.processActions = function () {
        if (_this.selectedItems.length > 0) {
            _this.executedActions = [];
            _this.processActionsNext();
        } else {
            toast.warning($translate.instant("DASHBOARD.DATA.NO_ACTION_SELECTED")); // "No hay acciones seleccionadas"
        }
    };

    _this.processActionsNext = function () {
        console.log(_this.selectedItems);
        if (_this.selectedItems.length > 0) {
            _this.processingActions = true;
            let item = _this.selectedItems.pop();
            
            let url = $serverData.server + '/runActions/' + encodeURIComponent(item.id) + '/';
            $http.get(url)
                .then(function (response) {
                    _this.loading = false;
                    toast.success($translate.instant("DASHBOARD.DATA.ACTION_PROCESSED")); // "Acción procesada"
                    _this.executedActions.push(item.id);
                    
                    if (_this.selectedItems.length == 0)
                        $timeout(function () {
                            _this.processingActions = false;
                        }, 2000);
                    else
                        setTimeout(_this.processActionsNext, 2000);
                    return;
                })
                .catch(function () {
                    _this.processingActions = false;
                    return;
                });
        }
    }

    // REPORTES
    _this.processReports = function () {
        if (_this.selectedItems.length > 0) {
            _this.executedReports = [];
            _this.processReportsNext();
        } else {
            toast.warning($translate.instant("DASHBOARD.DATA.NO_REPORT_SELECTED")); // "No hay reportes seleccionados"
        }
    };

    _this.processReportsNext = function () {
        console.log(_this.selectedItems);
        if (_this.selectedItems.length > 0) {
            _this.processingReports = true;
            let item = _this.selectedItems.pop();
            
            let url = $serverData.server + '/sendReport/' + encodeURIComponent(item.id) + '/';
            $http.get(url)
                .then(function (response) {
                    _this.loading = false;
                    toast.success($translate.instant("DASHBOARD.DATA.REPORT_PROCESSED")); // "Reporte procesado"
                    _this.executedReports.push(item.id);
                    
                    if (_this.selectedItems.length == 0)
                        $timeout(function () {
                            _this.processingReports = false;
                        }, 2000);
                    else
                        setTimeout(_this.processReportsNext, 2000);
                    return;
                })
                .catch(function () {
                    _this.processingReports = false;
                    return;
                });
        }
    }


    _this.exportXSLX = function () {
        const filterModel = _this.gridOptions.api.getFilterModel();
        _this.gridOptions.api.setRowData(_this.getRowsToExport());
        window.exportarAgGridAExcel(_this.gridOptions.api, _this.form.name.replace(' ', '_') + '.xlsx');
        _this.restoreGridAfterExport(filterModel);
        return;
    };


    function getUser(params) {
        if (params.data.member) {
            return params.data.member.firstName + ' ' + params.data.member.lastName;
        }
        return 'Usuario no encontrado';
    }
    function getUserMail(params) {
        if (params.data.member) {
            return params.data.member.email;
        }
        return '';
    }
    function getUserValidate(params) {
        if (params.data.validate) {
            params.data.validate = Array.isArray(params.data.validate) ? params.data.validate : [params.data.validate];
            if (params.data.validate.length > 0) {
                const validate = params.data.validate[params.data.validate.length - 1];
                return ((validate?.user?.firstName ? validate?.user?.firstName : '') + ' ' + (validate?.user?.lastName ? validate?.user?.lastName : ''));
            }
            return '';
        }
        return '';
    }
    function getDateValidate(params) {
        if (params.data.validate_lastUpdate) {
            return new Date(params.data.validate_lastUpdate)?.getYYYYMMddHHmmss();
        }
        return '';
    }
    function getCommentsValidate(params) {
        if (params.data.validate) {
            params.data.validate = Array.isArray(params.data.validate) ? params.data.validate : [params.data.validate]
            return params.data.validate.length > 0 ? params.data.validate[params.data.validate.length - 1]?.comments : '';
        }
        return '';
    }
    // La columna usa el cellRenderer <validate>, por lo que sin valueGetter el export no obtiene texto (validate es un array). Devolvemos el estado legible.
    function getStateValidate(params) {
        let validate = params.data.validate;
        validate = Array.isArray(validate) ? validate : (validate ? [validate] : []);
        if (validate.some(v => v && v.state === 'REJECT')) {
            return $translate.instant("DASHBOARD.DASH_VALIDATIONS.STATES.REJECT");
        }
        const isInstanceDefined = _this.form.validate_type === "instance-defined";
        const validateDefined = _this.form.validate_defined || [];
        const instances = _this.form.validate_instances || 1;
        const required = isInstanceDefined ? validateDefined.length : instances;
        if (validate.length > 0 && validate.length >= required) {
            return $translate.instant("DASHBOARD.DASH_VALIDATIONS.STATES.OK");
        }
        // Estado intermedio / pendiente: replicar el label dinámico que muestra la directiva <validate>.
        const pendingText = $translate.instant("DASHBOARD.DASH_VALIDATIONS.STATES.PENDING");
        if (isInstanceDefined && validate.length < validateDefined.length) {
            return validateDefined[validate.length].input || (pendingText + " #" + (validate.length + 1));
        }
        if (instances > 1) {
            return pendingText + " " + (instances - validate.length);
        }
        return pendingText;
    }

    this.viewMap = function () {
        _this.showMap = _this.showMap ? false : true;

        if (_this.showMap) {
            $scope.$broadcast('resetMap', true);
        } else {
            $scope.$broadcast('resetMap', false);
        }
    };

    this.viewTasks = function () {
        var controlCol = _this.gridOptions.columnApi.getColumn('task-name');
        if (!controlCol.visible) {
            _this.gridOptions.columnApi.setColumnVisible('task-name', true);
            _this.gridOptions.columnApi.setColumnVisible('task-client', true);
            _this.gridOptions.columnApi.setColumnVisible('task-description', true);
        } else {
            _this.gridOptions.columnApi.setColumnVisible('task-name', false);
            _this.gridOptions.columnApi.setColumnVisible('task-client', false);
            _this.gridOptions.columnApi.setColumnVisible('task-description', false);
        }
    };

    this.showElementArchived = function (view) {
        _this.viewElementArchived = view;
        _this.lstFieldsArchived.forEach(function (fieldId) {
            _this.gridOptions.columnApi.setColumnVisible(fieldId, view);
        });

    }

    this.selectAllStatus = false;
    this.selectAll = function (status) {
        if (status) {
            _this.gridOptions.api.forEachNodeAfterFilterAndSort(function (node) {
                _this.gridOptions.api.selectNode(node, true);
            });
            return;
        }
        _this.gridOptions.api.deselectAll();

        return;
    };

    this.removeSelectedItems = function () {
        if (!_this.selectedItems) {
            toast.error("Debes seleccionar al menos un item para eliminarlo");
            return;
        }

        if (!_this.selectedItems.length) {
            toast.error("Debes seleccionar al menos un item para eliminarlo");
            return;
        }

        var itemsArray = _this.selectedItems.map(function (item) {
            return item.id;
        });

        dialog.confirm({
            title: 'Eliminar items',
            body: '¿Desea eliminar ' + itemsArray.length + ' items?',
            accept: 'Eliminar',
            cancel: 'Cancelar',
            size: 'sm'
        }).then(function () {
            var deleteArray = [];

            itemsArray.forEach(function (item) {
                deleteArray.push(
                    function (callback) {
                        Form.prototype$__destroyById__items({
                            id: $state.params.formId,
                            fk: item
                        })
                            .$promise
                            .then(function () {
                                callback(null, true);
                            })
                            .catch(function (error) {
                                callback(error);
                            });
                    }
                );
            });

            async.series(deleteArray,
                function (err, result) {

                });

            _this.items = _this.itemsBkp.filter(function (item) {
                var inArray = false;
                for (var i = 0; i < itemsArray.length; i++) {
                    if (itemsArray[i] === item.id) {
                        inArray = true;
                    }
                }

                if (inArray) {
                    return false;
                }
                return true;
            });
            _this.itemsBkp = _this.items;
            _this.gridOptions.api.setRowData(_this.itemsBkp);
        });
    };

    $rootScope.$on("onValidateItem", function (event, data, $uibModalInstance) {
        for (let item of _this.itemsBkp) {
            if (item.id == data.id) {
                item.validate = data.validate;
                break;
            }
        }
        _this.gridOptions.api.setRowData(_this.itemsBkp);
    });

    var columnDefs = [{
        headerCellRenderer: gridConfiguration.selectAllRenderer,
        field: '',
        checkboxSelection: true,
        width: 50,
        suppressMenu: true,
        suppressSorting: true,
        pinned: 'left',
        suppressResize: true
    },
    {
        headerName: '',
        field: '',
        checkboxSelection: false,
        width: 70,
        suppressMenu: true,
        suppressSorting: true,
        suppressResize: true,
        pinned: 'left',
        cellRenderer: gridConfiguration.pdfRenderer
    },
    {
        headerName: '',
        field: '',
        checkboxSelection: false,
        width: 70,
        suppressMenu: true,
        suppressSorting: true,
        suppressResize: true,
        pinned: 'left',
        cellRenderer: gridConfiguration.HTMLRenderer
    },
    {
        headerName: 'Validación',
        field: 'validate.state', width: 100,
        checkboxSelection: false,
        pinned: 'left',
        filter: 'set',
        valueGetter: getStateValidate,
        cellRenderer: gridConfiguration.validateRenderer,
        hide: !_this.form.validate_required,
        filterParams: { cellHeight: 20, apply: true, newRowsAction: 'keep', values: _this.valuesPendingValidation },
        validateSpec: {
            instances: _this.form.validate_instances,
            type: _this.form.validate_type,
            pages: _this.form.validate_pages,
            users: _this.form.validate_users,
            currentUserTeamLeader: _this.currentUserIsTeamLeader,
            validate_defined: _this.form.validate_defined || [],
            allowCancel: _this.form.validate_allowCancel || false,
            allowCancelOptions: _this.form.validate_allowCancel_options || [],
            allowRejectOptions: _this.form.validate_allowReject_options || []
        }
    },
    {
        headerName: 'Comentarios',
        field: 'validate.comments',
        valueGetter: getCommentsValidate,
        checkboxSelection: false,
        filter: 'text',
        filterParams: { apply: true },
        hide: !_this.form.validate_required
    },
    {
        headerName: 'Validador',
        field: 'validate.user',
        valueGetter: getUserValidate,
        cellRenderer: gridConfiguration.validatorRenderer,
        filter: 'set',
        hide: !_this.form.validate_required,
        filterParams: { cellHeight: 20, apply: true, newRowsAction: 'keep', values: _this.owners }
    },
    {
        headerName: 'Fecha Validación',
        field: 'validate_lastUpdate',
        hide: !_this.form.validate_required,
        cellRenderer: gridConfiguration.timestampRenderer,
        valueGetter: getDateValidate,
        filter: gridConfiguration.dateFilter,
        comparator: gridConfiguration.dateComparator
    },
    {
        headerName: $translate.instant("DASHBOARD.DATA.COLS.USER"),
        field: 'member',
        valueGetter: getUser,
        cellRenderer: gridConfiguration.userRenderer,
        filter: 'set',
        filterParams: { cellHeight: 20, apply: true, newRowsAction: 'keep', values: _this.lstUsuarios }
    },
    {
        headerName: "eMail",
        field: 'member.email',
        valueGetter: getUserMail,
        filter: 'set',
        filterParams: { cellHeight: 20, apply: true, newRowsAction: 'keep', values: _this.lstMails }
    },
    {
        headerName: $translate.instant("DASHBOARD.DATA.COLS.STARTED_AT"),
        field: '_startedAt',
        cellRenderer: gridConfiguration.timestampRenderer,
        valueGetter: gridConfiguration.startedAtGetter,
        filter: gridConfiguration.dateFilter,
        comparator: gridConfiguration.dateComparator
    },
    {
        headerName: $translate.instant("DASHBOARD.DATA.COLS.CLOSED_REC"),
        field: 'closedAt',
        cellRenderer: gridConfiguration.timestampRenderer,
        valueGetter: gridConfiguration.closedAtGetter,
        filter: gridConfiguration.dateFilter,
        comparator: gridConfiguration.dateComparator
    },
    {
        headerName: $translate.instant("DASHBOARD.DATA.COLS.CREATED_AT"),
        field: '_createdAt',
        cellRenderer: gridConfiguration.timestampRenderer,
        valueGetter: gridConfiguration.createdAtGetter,
        filter: gridConfiguration.dateFilter,
        comparator: gridConfiguration.dateComparator
    },
    {
        headerName: $translate.instant("DASHBOARD.DATA.COLS.LAST_STEP"),
        field: 'lastStep',
        filter: "set",
        filterParams: { cellHeight: 20, apply: true, newRowsAction: 'keep', values: [true, false] },
        cellRenderer: gridConfiguration.checkboxRenderer,
        hide: !["workflow", "ptw"].includes(_this.form.type),
    },
    {
        headerName: $translate.instant("DASHBOARD.DATA.COLS.DELAY"),
        field: '_createdAt', suppressSorting: true, suppressMenu: true,
        valueGetter: gridConfiguration.demoraGetter,
        headerTooltip: $translate.instant("DASHBOARD.DATA.COLS.DELAY_TOOLTIP")
    },
    {
        headerName: $translate.instant("DASHBOARD.DATA.COLS.NAME"),
        field: 'task.name', suppressSorting: true, suppressMenu: true,
        colId: 'task-name',
        hide: ($state.params.taskId == undefined)
    },
    {
        headerName: $translate.instant("DASHBOARD.DATA.COLS.SITE"),
        field: 'task.client.name', suppressSorting: true, suppressMenu: true,
        colId: 'task-client',
        hide: ($state.params.taskId == undefined)

    },
    {
        headerName: $translate.instant("DASHBOARD.DATA.COLS.DESCRIP"),
        field: 'task.description', suppressSorting: true, suppressMenu: true,
        colId: 'task-description',
        hide: ($state.params.taskId == undefined)
    }];

    function createColDefs(form) {
        form.pages.forEach(function (page) {
            walkNodes(page.fields, columnDefs);
        });
        if (_this.currentUserIsAdmin) {
            columnDefs.push({
                headerName: "ID FIELD", colId: "id",
                field: "id", filter: "text",
                filterParams: { cellHeight: 20, apply: true, newRowsAction: 'keep' }

            });
            columnDefs.push({
                headerName: "PHONE.MODEL", colId: "phoneInformation.model",
                field: "phoneInformation.model", filter: "text",
                filterParams: { cellHeight: 20, apply: true, newRowsAction: 'keep' }
            });
            columnDefs.push({
                headerName: "PHONE.SO_VERSION", colId: "phoneInformation.systemVersion",
                field: "phoneInformation.systemVersion", filter: "text",
                filterParams: { cellHeight: 20, apply: true, newRowsAction: 'keep' }
            });
            columnDefs.push({
                headerName: "PHONE.PACKAGE", colId: "phoneInformation.package",
                field: "phoneInformation.package", filter: "text",
                filterParams: { cellHeight: 20, apply: true, newRowsAction: 'keep' }
            });
            columnDefs.push({
                headerName: "PHONE.FIELD_VERSION", colId: "phoneInformation.version",
                field: "phoneInformation.version", filter: "text",
                filterParams: { cellHeight: 20, apply: true, newRowsAction: 'keep' }
            });
        }
    }

    function walkNodes(fields, columnDefs) {
        fields.forEach(function (field) {
            var tempObject = {
                headerName: field.name || field.label, colId: field.id,
                field: field.id, filter: "text",
                filterParams: { cellHeight: 20, apply: true, newRowsAction: 'keep' },
                valueGetter: gridConfiguration.payloadGetter,
                hide: field.isArchived ?? false
            };
            if (field.isArchived)
                _this.lstFieldsArchived.push(field.id);

            if (field.type === 'title') {
                return;
            }
            if (field.type === 'populate') {
                return;
            }
            if (field.templateData?.hideGrid == true) {
                return;
            }
            if (field.type === 'number') {
                tempObject.filter = 'number';
                tempObject.cellRenderer = gridConfiguration.numberRenderer;
                tempObject.formData = field;
                tempObject.cellClass = 'my-right-aligned-cell';
            }
            if (field.type == "autonumeric") {
                tempObject.filter = isNaN(field.templateData?.lastValue || 0) ? 'text' : 'number';
                tempObject.cellRenderer = gridConfiguration.numberRenderer;
                tempObject.formData = field;
                tempObject.cellClass = 'my-right-aligned-cell';
            }
            if (field.type === 'formula') {
                var isTextFormula = field.templateData?.isAdvanced && field.templateData?.returnDataType === 'text';
                tempObject.filter = isTextFormula ? 'text' : 'number';
                tempObject.valueGetter = gridConfiguration.formulaGetter;
                tempObject.formData = field;
                tempObject.cellClass = isTextFormula ? undefined : 'my-right-aligned-cell';
            }

            if (field.type === 'text') {
                tempObject.filter = 'text';
            }
            if (field.type === 'qr') {
                tempObject.filter = 'text';
            }
            if (field.type === 'sign') {
                tempObject.cellRenderer = gridConfiguration.signRenderer;
                tempObject.suppressMenu = true;
                tempObject.suppressSorting = true;
                tempObject.field = field.id;
                tempObject.valueGetter = gridConfiguration.signGetter;
            }
            if (field.type === 'geo') {
                tempObject.cellRenderer = gridConfiguration.geoRenderer;
                tempObject.valueGetter = gridConfiguration.geoGetter;
                tempObject.field = field.id;
                tempObject.suppressMenu = true;
                tempObject.suppressSorting = true;
            }
            if (field.type === 'date') {
                tempObject.cellRenderer = gridConfiguration.dateRenderer;
                tempObject.valueGetter = gridConfiguration.dateGetter;
                tempObject.filter = gridConfiguration.dateFilter;
                tempObject.field = field.id;
                tempObject.comparator = gridConfiguration.dateComparator;
            }
            if (field.type === 'time') {
                tempObject.cellRenderer = gridConfiguration.timeRenderer;
                tempObject.valueGetter = gridConfiguration.timeGetter;
                tempObject.filter = undefined;
                tempObject.suppressMenu = true;
                tempObject.field = field.id;
                tempObject.comparator = gridConfiguration.dateComparator;
            }
            if (field.type === 'timestamp') {
                tempObject.cellRenderer = gridConfiguration.timestampRenderer;
                tempObject.valueGetter = gridConfiguration.timestampGetter;
                tempObject.suppressMenu = true;
                tempObject.field = field.id;
                tempObject.comparator = gridConfiguration.dateComparator;
            }
            if (field.type === 'checkbox') {
                tempObject.filter = "set";
                tempObject.filterParams["values"] = [true, false];
                tempObject.cellRenderer = gridConfiguration.checkboxRenderer;
            }
            if (field.type === 'photo') {
                tempObject.cellRenderer = gridConfiguration.photosRenderer;
                tempObject.valueGetter = gridConfiguration.photosGetter;
                tempObject.field = field.id;
                tempObject.suppressSorting = true;
                tempObject.suppressMenu = true;
            }
            if (field.type === 'video') {
                tempObject.cellRenderer = gridConfiguration.photosRenderer;
                tempObject.valueGetter = gridConfiguration.photosGetter;
                tempObject.field = field.id;
                tempObject.suppressSorting = true;
                tempObject.suppressMenu = true;
            }
            if (field.type === 'docs') {
                tempObject.cellRenderer = gridConfiguration.docsRenderer;
                tempObject.valueGetter = gridConfiguration.photosGetter;
                tempObject.field = field.id;
                tempObject.suppressSorting = true;
                tempObject.suppressMenu = true;
            }
            if (field.type === 'simplelist') {
                tempObject.cellRenderer = gridConfiguration.simpleListRenderer;
                tempObject.valueGetter = gridConfiguration.simpleListGetter;
                tempObject.field = field.id;
                tempObject.suppressMenu = true;
                tempObject.suppressSorting = true;
                tempObject.formData = { ...field, templateData: null, nodes: field.nodes.map(n => { return { ...n, templateData: { ...n.templateData, options: null } } }) };
            }
            if (field.type === 'select' || field.type === 'multiple') {
                tempObject.valueGetter = gridConfiguration.multipleGetter;
                tempObject.field = field.id;
                //tempObject.suppressMenu = true;
                tempObject.formData = { ...field, templateData: null };;
                let consolidateOptions = [];
                if (field.isDinamic) {
                    if (field.templateData.dynamicOptions) {
                        consolidateOptions = field.templateData.dynamicOptions.reduce((lst, cond) => [...new Set([...lst, ...cond.options])], []);
                    }
                } else if (field.templateData.options && field.templateData.options.length > 0) {
                    consolidateOptions = field.templateData.options;
                }
                if (consolidateOptions.length > 0 && consolidateOptions.findIndex(opt => opt.substring(0, 6) == "OTHER|") == -1) {
                    // Mostrar etiquetas sin prefijo "*|" / "n|" en el filtro set (coincide con multipleGetter)
                    const filterValues = consolidateOptions.map(function (opt) {
                        const s = String(opt);
                        const idx = s.indexOf("|");
                        return idx >= 0 ? s.substring(idx + 1) : s;
                    });
                    tempObject.filter = 'set';
                    tempObject.filterParams = { cellHeight: 20, apply: true, newRowsAction: 'keep', values: filterValues }
                }
            }
            if (field.type === 'group') {
                walkNodes(field.nodes, columnDefs)
                return;
            }

            columnDefs.push(tempObject);
        });
    }

    createColDefs(this.form);

    _this.datasource = {
        pageSize: _this.itemxPage,
        rowCount: null, // behave as infinite scroll
        getRows: function (params) {
            if (!_this.filterPrefs.isSyncBlocked()) {
                _this.filterPrefs.syncFromGrid(params.filterModel);
            }

            const requestFilterModel = _this.filterPrefs.getEffectiveForRequest();
            _this.filterPrefs.persistFromParams(
                Object.assign({}, params, { filterModel: requestFilterModel }));

            var oFilter = {};
            if ($state.params.taskId) {
                oFilter["taskId"] = $state.params.taskId;
            }
            var oMemberFilterArr = [];
            var oMemberMailFilterArr = [];
            if (requestFilterModel != undefined)
                Object.keys(requestFilterModel).forEach(campo => {

                    if (["_startedAt", "_createdAt", "closedAt", "validate_lastUpdate"].includes(campo)) {
                        if (_this.filterPrefs.isInvalidDateFilterEntry(requestFilterModel[campo])) {
                            oFilter[campo] = undefined;
                        } else {
                            oFilter[campo] = { between: [new Date(requestFilterModel[campo][0]), new Date(requestFilterModel[campo][1])] };
                        }
                    } else if (campo == "member") {
                        if (Array.isArray(requestFilterModel.member)) {
                            if (requestFilterModel.member.length === 0) {
                                oFilter.memberId = { "inq": [] };
                            } else {
                                requestFilterModel.member.forEach(m => {
                                    oMemberFilterArr.push(m.split("|")[1].trim());
                                });
                                if (oMemberFilterArr.length > 0) {
                                    oFilter.memberId = { "inq": oMemberFilterArr };
                                }
                            }
                        }
                    } else if (campo == "member.email") {
                        if (_this.filterPrefs.isEmptyFilterEntry(requestFilterModel["member.email"])) return;
                        requestFilterModel["member.email"].forEach(m => {
                            oMemberMailFilterArr.push(m.split("|")[1].trim());
                        });
                        oFilter.memberId = { "inq": oMemberMailFilterArr };
                    }
                    else if (campo === "validate.user") {
                        let oValidatorFilterArr = [];
                        requestFilterModel[campo].forEach(v => {
                            oValidatorFilterArr.push(v.split("|")[1].trim());
                        });
                        oFilter['validate.user._id'] = { "inq": oValidatorFilterArr };
                    } else {
                        let fieldPayload = campo.startsWith("validate.") ? campo : 'payload.' + campo + '.value';
                        let colType = _this.form.pages.reduce(function (retorno, page) {
                            return page.fields.reduce(function (retorno2, field) {
                                if (field.id == campo)
                                    return field.type;
                                else
                                    return retorno2;
                            }, retorno);
                        }, "")
                        // Validation filter
                        if (campo == "validate.state") {
                            let values = requestFilterModel[campo];
                            if (!Array.isArray(requestFilterModel[campo])) {
                                values = [requestFilterModel[campo].filter];
                            }
                            oFilter["or"] = [];

                            let rejectSelected = values.includes($translate.instant("DASHBOARD.DASH_VALIDATIONS.STATES.REJECT")); // "Rechazado"
                            let okSelected = values.includes($translate.instant("DASHBOARD.DASH_VALIDATIONS.STATES.OK")); // "Aprobado"

                            // Instance Defined with elements
                            if (_this.form.validate_type == "instance-defined" || _this.form.validate_instances > 1) {
                                let pendingInstance = [];
                                for (const value of values) {
                                    if (_this.pendingIndexes.has(value)) {
                                        pendingInstance.push(_this.pendingIndexes.get(value));
                                    }
                                }
                                // If Pending filters
                                if (pendingInstance.length > 0) {
                                    pendingInstance.forEach((instance) => {
                                        // Case firts pending filter, index == 0
                                        if (instance === 0) {
                                            oFilter["or"].push(
                                                { "validate": { "size": 0 } },
                                                { "validate": { "eq": null } }
                                            );
                                        }
                                        // Case pending filters index > 1 
                                        else {
                                            let validatePositionState = `validate.${instance - 1}.state`;
                                            let object = {
                                                "and": [
                                                    { "validate": { "size": instance } },
                                                    { [validatePositionState]: "OK" }
                                                ]
                                            }
                                            oFilter["or"].push(object)
                                        }
                                    })
                                }
                                // OK filter, last element in validate state OK
                                if (okSelected) {
                                    let validatePositionState = `validate.${_this.form.validate_instances - 1}.state`;
                                    oFilter["or"].push({
                                        "and": [
                                            { "validate": { "size": _this.form.validate_instances } },
                                            { [validatePositionState]: "OK" }
                                        ]
                                    });
                                }
                                // Any element in validate state REJECT
                                if (rejectSelected) {
                                    oFilter["or"].push(
                                        { "validate": { "elemMatch": { "state": "REJECT" } } }
                                    );
                                }
                            }
                            // Only one pending instance, validate has only one element
                            else {
                                let pendingSelected = values.includes("Pendiente"); // "Pendiente"
                                if (pendingSelected) {
                                    oFilter["or"].push(
                                        { "validate": { "size": 0 } },
                                        { "validate": { "eq": null } }
                                    );
                                }
                                if (okSelected) {
                                    oFilter["or"].push(
                                        { "validate": { "elemMatch": { "state": "OK" } } }
                                    );
                                }
                                if (rejectSelected) {
                                    oFilter["or"].push(
                                        { "validate": { "elemMatch": { "state": "REJECT" } } }
                                    );
                                }
                            }
                            if (oFilter["or"].length === 0) {
                                delete oFilter["or"];
                                console.log('Ninguna opción seleccionada');
                            }

                        } else if (Array.isArray(requestFilterModel[campo])) {
                            var filterValues = requestFilterModel[campo];
                            // ag-Grid Set Filter devuelve "true"/"false" como string. Convertir a boolean para checkbox.
                            if (colType === 'checkbox') {
                                filterValues = filterValues.map(function (v) {
                                    if (v === 'true' || v === true) return true;
                                    if (v === 'false' || v === false) return false;
                                    return v;
                                });
                            }
                            if (filterValues.length > 1)
                                if (colType == "date") {
                                    if (_this.filterPrefs.isInvalidDateFilterEntry(requestFilterModel[campo])) {
                                        oFilter[fieldPayload] = undefined;
                                    } else {
                                        oFilter[fieldPayload] = { between: [new Date(requestFilterModel[campo][0]), new Date(requestFilterModel[campo][1])] };
                                    }
                                } else { //Como string
                                    oFilter[fieldPayload] = { "inq": filterValues };
                                }
                            else {
                                // Checkbox "false" en BD suele ser null.
                                if (colType === 'checkbox' && filterValues[0] === false) {
                                    oFilter[fieldPayload] = { "inq": [false, null] };
                                } else {
                                    oFilter[fieldPayload] = filterValues[0];
                                }
                            }
                        } else {
                            if (typeof (requestFilterModel[campo].filter) == "string") {
                                if (requestFilterModel[campo].type == 1)
                                    oFilter[fieldPayload] = { "like": ".*" + requestFilterModel[campo].filter + ".*", "options": "i" }
                                else if (requestFilterModel[campo].type == 2)
                                    oFilter[fieldPayload] = { "like": requestFilterModel[campo].filter, "options": "i" };
                                else if (requestFilterModel[campo].type == 4)
                                    oFilter[fieldPayload] = { "like": ".*" + requestFilterModel[campo].filter, "options": "i" }
                                else if (requestFilterModel[campo].type == 3)
                                    oFilter[fieldPayload] = { "like": requestFilterModel[campo].filter + ".*", "options": "i" }
                            } else if (typeof (requestFilterModel[campo].filter) == "number") {
                                oFilter["and"] = oFilter["and"] || [{ "$expr": { "eq": [{ "$convert": { "input": "1", "to": "decimal", "onError": "", "onNull": "" } }, 1] } }];
                                if (requestFilterModel[campo].type == 1)
                                    oFilter["and"].push({ "$expr": { "eq": [{ "$convert": { "input": "$payload." + campo + ".value", "to": "decimal", "onError": "", "onNull": "" } }, requestFilterModel[campo].filter] } });
                                else if (requestFilterModel[campo].type == 2)
                                    oFilter["and"].push({ "$expr": { "lt": [{ "$convert": { "input": "$payload." + campo + ".value", "to": "decimal", "onError": "", "onNull": "" } }, requestFilterModel[campo].filter] } });
                                else if (requestFilterModel[campo].type == 3)
                                    oFilter["and"].push({ "$expr": { "gt": [{ "$convert": { "input": "$payload." + campo + ".value", "to": "decimal", "onError": "", "onNull": "" } }, requestFilterModel[campo].filter] } });
                            } else
                                oFilter[fieldPayload] = requestFilterModel[campo].filter;
                        }
                    }
                });
            let order = "_startedAt desc";
            if (Array.isArray(params.sortModel)) {
                params.sortModel.forEach(function (sortModel) {
                    if (["_createdAt", "_startedAt", "closedAt", "validate_lastUpdate"].includes(sortModel.colId))
                        order = sortModel.colId.concat(" ", sortModel.sort)
                });
            }
            let query = {
                departmentId: $state.params.departmentId,
                formId: $state.params.formId,
                sortModel: params.sortModel,
                filter: {
                    where: {
                        id: $state.params.formId,

                    },
                    include: {
                        relation: 'items',
                        scope: {
                            limit: (this.pageSize + 1),
                            skip: params.startRow,
                            order: order,
                            where: oFilter, //{ "memberId":{"inq":["57d0647f77fde8fd1764d631","57ed2bea39fee62459ef882f"]}},
                            include: [{
                                relation: 'member',
                            }, {
                                relation: 'task',
                                scope: {
                                    include: 'client'
                                }
                            }]
                        }
                    }
                }
            };

            //_this.Department.forms(query).$promise.then(function (data) {
            _this.Form.myItems({
                formId: $state.params.formId,
                departmentId: $state.params.departmentId
            }, query).$promise.then(function (data) {
                var rowsThisPage = [];
                var lastRow = -1;
                data = data.response || data;
                rowsThisPage = data[0].items;
                if (rowsThisPage.length <= (params.endRow - params.startRow)) {
                    lastRow = params.startRow + rowsThisPage.length;
                }
                if (data[0].members && Array.isArray(data[0].members)) {
                    for (const m of data[0].members) {
                        if (!_this.lstUsuarios.includes(m.firstName + " " + m.lastName + " | " + m.id)) {
                            _this.lstUsuarios.push(m.firstName + " " + m.lastName + " | " + m.id);
                            _this.lstMails.push(m.email + " | " + m.id);
                        }
                    }

                    const userCol = _this.gridOptions.columnDefs.find(c => c.field === 'member');
                    if (userCol) {
                        userCol.filterParams.values = _this.lstUsuarios;
                    }
                    const emailCol = _this.gridOptions.columnDefs.find(c => c.field === 'member.email');
                    if (emailCol) {
                        emailCol.filterParams.values = _this.lstMails;
                    }
                    const validatorCol = _this.gridOptions.columnDefs.find(c => c.field === 'validate.user');
                    if (validatorCol) {
                        validatorCol.filterParams.values = _this.lstUsuarios;
                    }
                    if (_this.gridOptions.api && _this.gridOptions.api.onNewRowsLoaded) {
                        _this.gridOptions.api.onNewRowsLoaded();
                    }
                    $timeout(function () {
                        _this.filterPrefs.restoreFromStorage();
                    }, 0);
                }
                // We backup the object to have a way to revert to it, since onlySelected does not work on this version of ag-grid
                _this.itemsBkp = rowsThisPage.slice(0, (params.endRow - params.startRow));
                params.successCallback(rowsThisPage.slice(0, (params.endRow - params.startRow)), lastRow);
            });
        }
    };

    this.gridOptions = {
        columnDefs: columnDefs,
        debug: false,
        rowBuffer: 0,
        pagination: true,
        paginationPageSize: _this.itemxPage,
        components: {
            loadingCellRenderer: function (params) {
                if (params.value !== undefined) {
                    return params.value;
                } else {
                    return '<img src="https://raw.githubusercontent.com/ag-grid/ag-grid/master/packages/ag-grid-docs/src/images/loading.gif">';
                }
            }
        },
        datasource: _this.datasource,
        rowHeight: 40,
        rowSelection: 'multiple',
        enableServerSideSorting: true,
        enableServerSideFilter: true,
        enableColResize: true,
        angularCompileRows: true,
        angularCompileFilters: true,
        angularCompileHeaders: true,
        onGridReady: function (grid) {
            grid.api.setHeaderHeight(40);
            _this.gridRestoringPreferences = true;
            if ($state.params.taskId == undefined) {
                const prefs = _this.filterPrefs.getPreferencesToRestore();
                if (prefs.state) {
                    _this.gridOptions.columnApi.setState(prefs.state);
                }
                _this.filterPrefs.loadPendingFilters(prefs.filterModel);
            }
            grid.api.addGlobalListener(function (type, event) {
                if (type != "columnEverythingChanged" && type.indexOf('column') >= 0) {
                    if (_this.gridInitState && _this.filterPrefs.canPersist()) {
                        _this.filterPrefs.persistToLocalStorage();
                    }
                    _this.gridInitState = true;
                }
            });
            $timeout(function () {
                _this.gridRestoringPreferences = false;
                _this.gridInitState = true;
                _this.filterPrefs.restoreFromStorage();
                $timeout(function () {
                    _this.notifyValidationModalFiltersState();
                }, 250);
            }, 200);
        },
        onAfterFilterChanged: function () {
            _this.filterPrefs.onFilterChanged();
            $timeout(function () {
                _this.notifyValidationModalFiltersState();
            }, 0);
        },
        onModelUpdated: function () {
            _this.filteredItems = [];
            for (var i = 0; i < _this.gridOptions.api.inMemoryRowController.rowsToDisplay.length; i++) {
                _this.filteredItems.push(_this.gridOptions.api.inMemoryRowController.rowsToDisplay[i].data);
            }
            $scope.$broadcast('resetMap', true, _this.filteredItems);
            _this.loading = false;
        },
        onSelectionChanged: function (selection) {
            _this.selectedItems = selection.selectedRows;
            _this.filteredItems = selection.selectedRows;
            if (_this.filteredItems.length === 0) {
                _this.filteredItems = [];
                for (var i = 0; i < _this.gridOptions.api.inMemoryRowController.rowsToDisplay.length; i++) {
                    _this.filteredItems.push(_this.gridOptions.api.inMemoryRowController.rowsToDisplay[i].data);
                }
            }
            $scope.$broadcast('resetMap', true, _this.filteredItems);

        },
        localeText: gridConfiguration.localeText
    };

    this.refreshData = function () {
        _this.loading = true;
        if (_this.gridOptions && _this.gridOptions.api) {
            _this.gridOptions.api.setDatasource(_this.datasource);
        }
    };

    $scope.$on('dataGrid-resetFilters', function () {
        _this.resetFilters();
    });
};